export function commas(value: string | number | bigint): string {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export function ellipsisAddress(address: string, characters: number = 6, mobile: boolean = false): string {
  if (mobile) {
    return `${address.slice(0, characters)}...${address.slice(-4)}`
  }
  return `${address.slice(0, characters + 2)}...${address.slice(-characters)}`
}

export function timeSince(timestamp: number): string | null {
  const now = Date.now()
  const seconds = Math.floor((now - timestamp) / 1000)

  let interval = seconds / 31536000
  if (isNaN(interval)) {
    return null
  }
  if (interval > 1) {
    return Math.floor(interval) + ' years'
  }
  interval = seconds / 2592000
  if (interval > 1) {
    return Math.floor(interval) + ' months'
  }
  interval = seconds / 86400
  if (interval > 1) {
    return Math.floor(interval) + ' days'
  }
  interval = seconds / 3600
  if (interval > 1) {
    return Math.floor(interval) + ' hours'
  }
  interval = seconds / 60
  if (interval > 1) {
    return Math.floor(interval) + ' minutes'
  }
  return Math.floor(seconds) + ' seconds'
}

export function secondsToHuman(seconds: number): string {
  const date = new Date(seconds * 1000)
  return date.toLocaleString()
}

